import { Action } from '../../common/actions/core/action';

export class OpenMasterpassCardLinkAction implements Action {
  constructor(public onApprove:() => any
              ) {}
}



// WEBPACK FOOTER //
// src/app/buy/masterpass-card-link-dialog/masterpass-card-link-dialog.action.ts